<template>
  <router-link :to="getRouteName">
    <div :class="className">
      <span>{{ name }}</span>
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    position: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    className() {
      if (this.position) return `label label--${this.name.toLowerCase()}`;
      else return `absolute label label--${this.name.toLowerCase()}`;
    },
    getRouteName() {
      const setRouteName = entityType => {
        switch (entityType) {
          case 'Resident':
            return { name: 'Residents' };
          case 'Guest':
            return { name: 'Guests' };
          case 'episode':
            return { name: 'Latest' };
          case 'series':
            return { name: 'SeriesAll' };
          case 'show':
            return { name: 'ShowsAll' };
          default:
            return { name: 'Home' };
        }
      };
      return setRouteName(this.name);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_label.scss';
</style>
